import menuInit from './menu';
import navbarInit from './navbar';
import scriptInit from './faq';

window.onload = async () => {
  if (document.getElementsByClassName('slider').length) {
    import('./slider').then((module) => module.default());
  }
};

document.addEventListener('DOMContentLoaded', () => {
  import(/* webpackPrefetch: true */ './icons');
  menuInit();
  navbarInit();
  scriptInit();
});
